





















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class EsConfDetail extends Vue {
  @Prop() esConf!: any;
}
